export const featureTemplate = {
  '_template': 'feature',
  'media': {
    'showImage': 'false',
    'box': {
      'margin': {
        'marginBottom': {
          'xl': 10
        }
      },
      'size': {
        'width': {
          'xl': 0
        }
      }
    },
    'align': 'center',
    'src': '/placeholder.jpg'
  },
  'title': {
    'es': 'Marie Skłodowska Curie',
    'en': 'Marie Skłodowska Curie'
  },
  'subText': {
    'es': 'Rich in mystery muse about vastness is bearable only through love Ut enim ad minima veniam at the edge of forever are creatures of the cosmos. ',
    'en': 'Rich in mystery muse about vastness is bearable only through love Ut enim ad minima veniam at the edge of forever are creatures of the cosmos. '
  },
  'background': {
    'backgroundColor': ''
  },
  'box': {
    'padding': {
      'paddingTop': {

      },
      'paddingRight': {
        'xl': 12
      },
      'paddingBottom': {
        'xl': 10
      },
      'paddingLeft': {
        'xl': 12
      }
    }
  }
};

export const featuresTemplate = {
  _template: 'features',
  blocks: [
    featureTemplate,
    featureTemplate,

  ],
  text: {
    align: {
      xl: 'center'
    }
  }
};
